export const strataPlanConstants = {
  BASE_PATH: '/v1/building_profile/site_plans',
  GET_STRATA_PLANS: 'GET_STRATA_PLANS',
  SET_STRATA_PLANS_LOADING: 'SET_STRATA_PLANS_LOADING',
};
